import { Panel } from "./Panel";

type EmptyStateProps = {
  title: string;
  message: string;
  compact?: boolean;
  actionLabel?: string;
  onAction?: () => void;
};

export function EmptyState({ title, message, compact = false, actionLabel, onAction }: EmptyStateProps) {
  return (
    <Panel className={compact ? "empty-state compact-empty-state" : "empty-state"}>
      <h3>{title}</h3>
      <p>{message}</p>
      {actionLabel && onAction && (
        <div className="actions">
          <button type="button" className="button-primary-action" onClick={onAction}>
            {actionLabel}
          </button>
        </div>
      )}
    </Panel>
  );
}
